// extracted by mini-css-extract-plugin
module.exports = {"Container":"Layout-module--Container--2fijZ","Content":"Layout-module--Content--2GF7y"};